import React from "react";
import { mentors } from "../../blog/data/blogData/BlogData";
import "./../../../../assets/css/general/blog/MentorSpotlight/MentorSpotlight.css";

const MentorSpotlight = () => {
  return (
    <section className="mentor-spotlight-section">
      <div className="mentor-spotlight-container">
        <div className="mentor-spotlight-header">
          <h2 className="mentor-spotlight-title">
            Learn From{" "}
            <span className="mentor-spotlight-prefix">Industry Mentors</span>
          </h2>
          <p className="mentor-spotlight-subtitle">
            Our expert mentors share practical knowledge, real-world insights,
            and proven roadmaps to help you grow in tech.
          </p>
        </div>

        <div className="mentor-spotlight-grid">
          {mentors.map((mentor) => (
            <div key={mentor.id} className="mentor-spotlight-card">
              <div className="mentor-spotlight-image-wrapper">
                <img
                  src={mentor.image}
                  alt={mentor.name}
                  className="mentor-spotlight-image"
                />
              </div>

              <div className="mentor-spotlight-content">
                <h3 className="mentor-spotlight-name">{mentor.name}</h3>
                <p className="mentor-spotlight-role">{mentor.title}</p>

                <div className="mentor-spotlight-expertise">
                  {mentor.expertise.map((skill, index) => (
                    <span key={index} className="mentor-expertise-tag">
                      {skill}
                    </span>
                  ))}
                </div>

                <p className="mentor-spotlight-bio">{mentor.bio}</p>

                <div className="mentor-spotlight-stats">
                  <div className="mentor-stat-item">
                    <span className="mentor-stat-value">{mentor.articles}</span>
                    <span className="mentor-stat-label">Articles</span>
                  </div>
                  <div className="mentor-stat-divider"></div>
                  <div className="mentor-stat-item">
                    <span className="mentor-stat-value">
                      {mentor.experience}+
                    </span>
                    <span className="mentor-stat-label">Years Exp</span>
                  </div>
                </div>

                <button type="button" className="mentor-spotlight-cta">
                  View Articles →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MentorSpotlight;
